import { GLOBALS, TenantKey } from './global.environment';
import { WorkUseremploymentSalaryIntervalEnum } from '@work-frontend-monorepo/work-rest-api';

export const AXOVA_GLOBALS = {
  ...GLOBALS,
  tenantKey: 'axova' as TenantKey,
  tenantCompany: 'Axova AG',
  tenantCompanyCommonName: 'Axova',
  tenantAdministrationEmail: 'info@axova.ch',
  // Standorte wie auf der Website. Zug hat dort bewusst keinen Maps-Link.
  locations: [
    {
      region: 'Nordwestschweiz',
      street: 'Löhrweg 6',
      zipCity: '4442 Diepflingen/BL',
      mapsUrl: 'https://maps.app.goo.gl/voLHxKtW1xqQ57kbA',
    },
    { region: 'Mittelland', street: 'Feldmatte 4', zipCity: '5726 Unterkulm/AG', mapsUrl: 'https://maps.app.goo.gl/bcxeX8ppNhNtGyJU6' },
    { region: 'Zentralschweiz', street: 'Chamerstrasse 172', zipCity: '6300 Zug/ZG', mapsUrl: '' },
  ],
  tenantLogoPath: 'assets/svg/axova_logo.svg',
  tenantOfficeLogoPath: 'assets/svg/axova_logo_office.svg',
  tenantHeroGraphicOrIcon: 'assets/images/Sunny.webp',
  tenantFaviconPath: 'assets/favicons/ax_favicon.ico',
  disabledModulesForTenant: [],
  workOffice: {
    appName: 'Axova Office',
    topNavigationLogoVariant: 'white',
  },
  support: {
    ...GLOBALS.support,
    apiKey: 'axova-f05c3950b3c52e99aba46e55345fdd7a',
    appName: 'Axova-Office',
    primaryColor: '#51AB3B',
    title: 'Fehler entdeckt oder eine Frage zum Axova-Office?',
    subtitle: 'Beschreibe dein Anliegen – wir melden uns.',
  },
  workStates: {
    names: {
      favorites: 'ax_state__favorite',
      filter: 'ax_state__filter',
      loading: 'ax_state__loading',
      profile: 'ax_state__profile',
      reload: 'ax_state__reload',
      widgets: 'ax_state__widgets',
      terminAssistent: 'axova_ta__state',
      // a name needs to be set, even if not used. Compile-error otherwise
      tenants: 'ax_state__tenants',
      sfgGeruest: 'sfg_geruest',
    },
  },
  useremploymentDefaults: {
    targetHours: 8.5,
    holidaysPerYear: 27,
    salaryInterval: WorkUseremploymentSalaryIntervalEnum.Months13,
  },
  qrNumberPrefix: '20660 0',
  reservationLeadDefaults: { leadcategoryId: 34, leadsubcategoryId: 24 },
  verkehrsbussenDocumentsubtypeId: 36,
  showDebtorPartialCategories: true,
  montageplanShowObjectAddressByDefault: true,
  firebaseWebPush: {
    apiKey: 'AIzaSyCzfxnCKikxz5tYe_SE-imVR1GX4oe3nxk',
    projectId: 'axova-9c0f8',
    messagingSenderId: '671948311025',
    appId: '1:671948311025:web:931ec1e4360ee61fb91c50',
    vapidKey: 'BKZDfrb7jHd9wU7ZXx_pLWX9l_nv-XtYsy2DO_4HQCPrygF96WGTqHiQF32Kk7sBPBli6AXGMEi2Q9aJmZA8CPM',
  },
};
